import { getIdToken } from "./auth/cognito.js";

// Same-origin: CloudFront routes /api/* to the API Gateway origin.
const API_URL = (import.meta.env.VITE_API_URL ?? "/api").replace(/\/$/, "");

export class StudentError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

/** Authenticated request to /student/*. Attaches the student Cognito ID token. */
export async function api<T = unknown>(
  path: string,
  opts: { method?: string; body?: unknown } = {}
): Promise<T> {
  const token = await getIdToken();
  if (!token) throw new StudentError(401, "Your session expired - please sign in again.");
  const res = await fetch(`${API_URL}${path}`, {
    method: opts.method ?? "GET",
    headers: {
      Authorization: token,
      ...(opts.body ? { "content-type": "application/json" } : {}),
    },
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  if (res.status === 204) return undefined as T;
  const data = (await res.json().catch(() => ({}))) as Record<string, unknown>;
  if (!res.ok) {
    const err = data.error as { message?: string } | undefined;
    throw new StudentError(res.status, err?.message ?? "Request failed");
  }
  return data as T;
}
